jQuery(document).on('click', '#load-more-posts', function(e) {
    e.preventDefault();
    var debug = false;
    var button = jQuery(this);
    var targetElem = jQuery( button.data('target') );
    var loader = jQuery('#loading');

    if(targetElem.length) {

        var post_type = button.data('posttype');
        var date_start = button.data('datestart');
        var date_to = button.data('dateto');
        var keyword = button.data('keyword');
        var paged = parseInt(button.data('paged')) + 1;
        var category = button.data('category');
        var additional_category = button.data('additional-category');
        var pinned = button.data('pinned');

        var lang = button.data('lang');
        var action = 'vktheme_print_news_list';
        if(post_type == 'event')
            action = 'vktheme_print_events_list';

        if(typeof ajaxurl === 'undefined') {
            ajaxurl = button.data('ajaxurl');
        }
        var inputData = {
            action: action,
            date_start: date_start,
            date_to: date_to,
            keyword: keyword,
            category_slug: category,
            additional_category: additional_category,
            post_type: post_type,
            pinned: pinned,
            paged: paged,
            lang: lang
        };

        button.hide();
        button.data('paged', paged);
        loader.show();

        if(debug)
            console.log("Creating ajax request with parameters: ", inputData);

        var result = jQuery.post( ajaxurl, inputData, function( data ) {
            targetElem.append( data.html );
            loader.hide();
            if(data.more == '1')
                button.show();
            if(debug)
                console.log("loaded data: ", data, targetElem);
        }.bind(targetElem), 'json')
        .fail(function() {
            button.hide();
            loader.hide();
        });
    }
});
